import { render, staticRenderFns } from "./PidSecret.vue?vue&type=template&id=5f120da0&scoped=true"
import script from "./PidSecret.vue?vue&type=script&lang=js"
export * from "./PidSecret.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f120da0",
  null
  
)

export default component.exports